<!--The content below is only a placeholder and can be replaced.-->
<alert class="floating-alert"></alert>
<router-outlet></router-outlet>
